import { render, staticRenderFns } from "./BankPayway.vue?vue&type=template&id=4b41140c&scoped=true&"
import script from "./BankPayway.vue?vue&type=script&lang=js&"
export * from "./BankPayway.vue?vue&type=script&lang=js&"
import style0 from "./BankPayway.vue?vue&type=style&index=0&id=4b41140c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b41140c",
  null
  
)

export default component.exports